module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticStyle: {
      "border-top": "0.1rem solid #ededed"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "hotComments"
  }, [_vm._m(0), _vm._v(" "), _c('commentContent', {
    attrs: {
      "items": _vm.hotComments,
      "govImage": _vm.govImage
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hot_top"
  }, [_c('div', {
    staticClass: "hotLogo"
  }, [_vm._v("热门评论")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3db53a12"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/comments/hotComments.vue
// module id = 319
// module chunks = 1